module.exports = __webpack_public_path__ + "static/news2-pic7-b5a7291ff2190b32a59526b6ddf49cee.jpg";